export const bannerData = {
  img: require("@/assets/img/sdp/SDP-banner.png"),
  title: "SPD 供应商图档发布系统",
  text: "使供应商可以在一个平台内，完成流程审批、消息通知、对外文件收发、过期自动销毁的完整业务过程，实现了对文件外发全生命周期的可见性。",
  link: "Register",
  linkText: "开始免费试用",
}
export const contentData = [
  {
    icon: require("@/assets/img/sdp/安全通道icon.svg"),
    title: "安全通道",
    text: "图纸文件安全外发解决方案，帮 助制造型企业，建立安全可控、 全程记录的文件外发统一通道。",
    bgColor: "#caddfd",
    bgDecorate: "#a3c5fe",
    img: require("@/assets/img/sdp/安全通道.png"),
    anchor: 'spd-exit-passageway'
  },
  {
    icon: require("@/assets/img/sdp/数据安全icon.svg"),
    title: "数据安全",
    text: "数据发送、内容检查、审核审批、" +
      "消息通知、数据接收、历史审计、" +
      "归档销毁的完整业务过程，实现" +
      "了对文档外发管理全生命周期的" +
      "可见性。",
    bgColor: "#cdf1e4",
    bgDecorate: "#a3e7d0",
    img: require("@/assets/img/sdp/数据安全.png"),
    anchor: 'spd-data-security'
  },
  {
    icon: require("@/assets/img/sdp/流程管理icon.svg"),
    title: "流程管理",
    text: "内部用户-图纸发送-技术性审批" +
      "(加密、权限检查等)-流程审批-" +
      "访问控制(即阅即毁)-收件箱(通" +
      "知、下载) -外部用户(供应商)",
    bgColor: "#caddfd",
    bgDecorate: "#a3c5fe",
    img: require("@/assets/img/sdp/流程管理.png"),
    anchor: 'spd-process-management'
  },
]

export const anchorMenuData = [
  {
    anchor: 'spd-exit-passageway',
    icon: require("@/assets/img/sdp/icon-2.svg"),
    title: '安全通道',
    type: 1
  },
  {
    anchor: 'spd-data-security',
    icon: require("@/assets/img/sdp/icon-3.svg"),
    title: '数据安全',
    type: 1
  },
  {
    anchor: 'spd-process-management',
    icon: require("@/assets/img/sdp/icon-5.svg"),
    title: '流程管理',
    type: 1
  }
]
